import { createResource } from 'react-resource-router';

import { PredefinedQueries } from '../../common/constants';
import { type ResourceDependencies } from '../../common/types';

import { fetchAlerts } from './endpoints';

export const createOpenAlertsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'openAlertsResource',
		getKey: () => 'openAlertsResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return fetchAlerts({ searchParams: { query: PredefinedQueries.MY_OPEN_ALERTS, limit: 3 } });
		},
		isBrowserOnly: true,
		depends,
	});

export const createAckedAlertsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'ackedAlertsResource',
		getKey: () => 'ackedAlertsResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return fetchAlerts({ searchParams: { query: PredefinedQueries.MY_ACKED_ALERTS, limit: 3 } });
		},
		isBrowserOnly: true,
		depends,
	});

export const createSnoozedAlertsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'snoozedAlertsResource',
		getKey: () => 'snoozedAlertsResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return fetchAlerts({
				searchParams: { query: PredefinedQueries.MY_SNOOZED_ALERTS, limit: 3 },
			});
		},
		isBrowserOnly: true,
		depends,
	});

export const openAlertsResource = createOpenAlertsResource();
export const ackedAlertsResource = createAckedAlertsResource();
export const snoozedAlertsResource = createSnoozedAlertsResource();

export const widgetResources = [
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createOpenAlertsResource(callback, depends),
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createAckedAlertsResource(callback, depends),
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createSnoozedAlertsResource(callback, depends),
];
